<template>
<div>
    <v-list-item
        v-for="(item, index) in meta_data"
        :key="index"
    >
        <v-list-item-avatar
            v-on:click="$rc.openBlob(item.object_name);"
            style="cursor: pointer"
        > 
            <v-icon size="35" style="padding: 0">mdi-file-pdf-box</v-icon>
        </v-list-item-avatar>

        <v-list-item-content
            v-on:click="$rc.openBlob(item.object_name);"
            style="cursor: pointer"
        >
            <v-list-item-title
                style="text-decoration: underline; color: blue;"
            >
                {{item.label}}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</div>
</template>

<script>
export default {
    props: {
        meta_data: {
            type: Array,
            default: function() { return []; }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>